/* eslint-disable react/prop-types */
import React, { useMemo, memo } from "react";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import { Row, Col, Card } from "react-bootstrap";
import AdvanceTableSearchBox from "components/common/advance-table/AdvanceTableSearchBox";
import ExportButton from "components/common/advance-table/ExportButton";
import PropTypes from 'prop-types';
import conversationColumns from "./conversationColumns";
import RowDetailModal, { useRowDetail } from "./RowDetailModal";

const ResultsTable = ({ data, loading }) => {
    const { detail, openDetail, closeDetail } = useRowDetail();

    const tableProps = useMemo(() => ({
        bordered: true,
        striped: true,
        className: 'fs--1 mb-0',
        responsive: true
    }), []);

    return (
        <Card className="p-3">
            <AdvanceTableWrapper
                columns={conversationColumns}
                data={data}
                sortable
                perPage={1000}
                pagination={1000}
            >
                <Row className="justify-content-between mb-3 mt-1">
                    <Col xs="auto">
                        <ExportButton table />
                    </Col>
                    <Col xs="auto">
                        <AdvanceTableSearchBox table placeholder='Search...' />
                    </Col>
                </Row>
                <div className="sticky-zone-stillages">
                    <AdvanceTable
                        table
                        headerClassName="bg-200 text-nowrap align-middle sticky-header-stillages"
                        rowClassName={`align-middle white-space-nowrap cursor-pointer`}
                        tableProps={tableProps}
                        loading={loading}
                        handleClickRow={openDetail}
                    />
                </div>
            </AdvanceTableWrapper>
            <RowDetailModal detail={detail} onHide={closeDetail} />
        </Card>
    )
}

ResultsTable.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
};

export default memo(ResultsTable);